import { MutableRefObject, createContext } from "react";

const HomeCalendarContext = createContext<
  MutableRefObject<HTMLDivElement> | undefined
>(undefined);

export default HomeCalendarContext;
